export default __webpack_public_path__ + "static/media/city1.fadfec7c.jpg";